import SpotContent from './SpotContent';
import SpotHeader from './SpotHeader';

const Spot = {
  Content: SpotContent,
  Header: SpotHeader
};

export default Spot;
